import * as React from "react";
import {Adresse} from "../aside/adresse";
import {NavigationConfiguration} from "../../../../config/navigation-configuration";
import {Item} from "semantic-ui-react";
import {withStore} from "../../../../core/stores/abstract-app-store";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";

export interface KontaktProps {
    store?: MapViewerStore; // this is injected by withStore
}

class KontaktBase extends React.Component<KontaktProps, any> {
    constructor(props: KontaktProps) {
        super(props);
    }
    componentDidMount(): void {
        const { store } = this.props;
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { title: "Kontakt" }
        ];
        store?.appStore.setBreadcrumbs(breadcrumbs);
        store?.appStore.setPageTitle("Kontakt");
        store?.appStore.setAsideContent(null);
        store?.oStore.setShowMap(false);
    }
    render(): React.ReactElement | null {
        const { store } = this.props;
        if (!store){
            return null;
        }
        const { mapViewerConfig } = store;
        return(
            <div><p>Für weitere Informationen zum Objektwesen Luzern und zum Informationssystem sowie für allgemeine
                Fragen wenden Sie sich bitte an folgende Stellen:</p>
            <Item.Group>
                <Item>
                    <Adresse adresse={"kontakt_intern"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
                <Item>
                    <Adresse adresse={"kontakt_extern"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
                <Item>
                    <Adresse adresse={"kontakt_technisch"} mapViewerConfig={mapViewerConfig} heading={"h3"} />
                </Item>
            </Item.Group>
            </div>
        );
    }
}

export const Kontakt = withStore(KontaktBase);
